import React, {useRef} from 'react'
import PropTypes from 'prop-types'
import {useShippingMethodsForShipment} from '@salesforce/commerce-sdk-react'
import {Text} from '@salesforce/retail-react-app/app/components/shared/ui'

const PaymentMethodLabel = ({basket, style}) => {
    const shippingMethodGet = useRef(false)
    const {data: shippingMethods} = useShippingMethodsForShipment(
        {
            parameters: {
                basketId: basket?.basketId,
                shipmentId: 'me',
            },
        },
        {
            enabled: Boolean(basket?.basketId) && shippingMethodGet.current === false,
            onSuccess: () => (shippingMethodGet.current = true),
        },
    )

    const shippingMethodsLabelsMap = React.useMemo(() => {
        return shippingMethods?.applicableShippingMethods?.reduce((map, method) => {
            map[method.id] = method.c_estimatedArrivalTime
            return map
        }, {})
    }, [shippingMethods])

    return (
        <Text {...style?.subtotalSection?.shippingEstimationn}>
            {shippingMethodsLabelsMap?.[basket.shipments?.[0].shippingMethod?.id] ||
                basket.shipments?.[0].shippingMethod?.c_estimatedArrivalTime}
        </Text>
    )
}

PaymentMethodLabel.propTypes = {
    basket: PropTypes.shape({
        basketId: PropTypes.string,
        shipments: PropTypes.arrayOf(
            PropTypes.shape({
                shippingMethod: PropTypes.shape({
                    id: PropTypes.string,
                    c_estimatedArrivalTime: PropTypes.string,
                }),
            }),
        ),
    }),
    style: PropTypes.object,
}

export default PaymentMethodLabel
